import "../index.css";
import { floatToPrice } from "../../../functions/price_functions";



type PropsProductInfo = {
 config:any;
 product:any;
 price:number;
 promotionalPrice:number;

}


export function ProductInfo({
    config,
    product,
    price,
    promotionalPrice
}:PropsProductInfo) {



    return (
        <div className="product_info_container">
            <div className="product_title">
                <span className="product_ref">
                    <b>REF:</b>{" "}
                    {product?.code ? product.code : "Código não encontrado"}
                </span>

                {config?.content.showProductMark && (
                    <span className="product_mark">
                        <b>Marca:</b> {product?.mark ? product.mark.name : "-/-"}
                    </span>
                )}

                <span className="product_model">
                    <b>Modelo:</b> {product?.name}
                </span>
            </div>

            <div
                className="product_price"
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "center",
                }}
            >
                {promotionalPrice !== 0 && promotionalPrice !== price ? (
                    <>
                        <span className="old_price">{floatToPrice(price)}</span>
                        <span className="promotional_price">
                            {floatToPrice(promotionalPrice)}
                        </span>
                    </>
                ) : (
                    <span className="promotional_price">
                        {floatToPrice(price)}
                    </span>
                )}
            </div>
        </div>
    )
}